module.exports = __webpack_public_path__ + "img/suivre-dossier-bl.5256dc3a.svg";